// header.js (hardened)

(function () {
  /* ---------- tiny helper ---------- */
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
    document.addEventListener("shopify:section:load", fn);
    document.addEventListener("shopify:section:select", fn);
  }

  /* ---------- main header init ---------- */
  function initHeader() {
    const body = document.body;
    const headerEl = document.querySelector(".header");

    const openBtn   = document.querySelector(".header__offcanvas-toggle");
    const closeBtn  = document.querySelector(".header__offcanvas-toggle-link--close");
    const offMenu   = document.querySelector(".header__offcanvas-menu");
    const searchDetails = document.querySelector(".header__details");
    const submenuDetails = document.querySelectorAll(".header__submenu li details");

    const headerHiddenMenu = document.querySelector(".header__inline-menu");
    const openSearchBtn    = document.querySelector(".header__search");

    /* --- guards: stop if key pieces are missing on this template --- */
    // We can still run search pieces even when offcanvas is absent.
    const hasOffcanvas = !!(openBtn && closeBtn && offMenu);

    const openMenu = (e) => {
      if (!hasOffcanvas) return;
      e?.preventDefault?.();
      offMenu.classList.remove("header__offcanvas-menu--close");
      offMenu.classList.add("header__offcanvas-menu--open");
      openBtn.classList.add("active");
      body.classList.add("body--hidden");
      if (closeBtn) closeBtn.style.display = "block";
      openBtn.style.display = "none";
      headerHiddenMenu && (headerHiddenMenu.style.display = "none");
    };

    const closeMenu = () => {
      if (!hasOffcanvas) return;
      offMenu.classList.remove("header__offcanvas-menu--open");
      offMenu.classList.add("header__offcanvas-menu--close");
      openBtn.classList.remove("active");
      body.classList.remove("body--hidden");
      if (closeBtn) closeBtn.style.display = "none";
      openBtn.style.display = "block";
      headerHiddenMenu && (headerHiddenMenu.style.display = "block");
      headerEl && headerEl.classList.remove("search-header--opened");
    };

    // Bind only when the elements exist (prevents "addEventListener of null")
    if (openBtn)  openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", (e) => { e.preventDefault(); closeMenu(); });

    // Submenu: allow only one <details> open at a time
    submenuDetails.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        submenuDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
            headerEl && headerEl.classList.remove("search-header--opened");
          }
        });
      });
    });

    // ESC closes menus/search
    document.addEventListener("keyup", (e) => {
      if (e.key !== "Escape") return;
      closeMenu();
      searchDetails?.removeAttribute("open");
      body.classList.remove("overflow-hidden", "search-overflow-hidden");
      headerEl && headerEl.classList.remove("search-header--opened");
    });

    // Toggle search overlay state
    if (openSearchBtn && searchDetails) {
      openSearchBtn.addEventListener("click", () => {
        if (searchDetails.open) {
          body.classList.add("overflow-hidden", "search-overflow-hidden");
          headerEl && headerEl.classList.add("search-header--opened");
        } else {
          body.classList.remove("overflow-hidden", "search-overflow-hidden");
          headerEl && headerEl.classList.remove("search-header--opened");
        }
      });
    }

    // Sticky overlay header on scroll (native; no jQuery dependency)
    const headerOverlayAlways = document.querySelector(".overlay");
    const onScroll = () => {
      if (!headerOverlayAlways || !headerEl) return;
      if (window.scrollY > 50) headerEl.classList.add("header_overlay-scroll");
      else headerEl.classList.remove("header_overlay-scroll");
    };
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll);
    onScroll(); // set initial state
  }

  /* ---------- one-off binds outside init ---------- */

  // Close search modal button
  function bindSearchCloseButton() {
    const btn = document.querySelector(".search-modal-close-button");
    const headerEl = document.querySelector(".header");
    const details = document.querySelector(".header__details");
    if (!btn) return;
    btn.addEventListener("click", function () {
      headerEl && headerEl.classList.remove("search-header--opened");
      details?.removeAttribute("open");
    });
  }

  // Predictive search tabs
  function bindPredictiveSearchTabs() {
    const searchTabs = document.querySelectorAll(".predictive-search__result-tab");
    const results = document.querySelectorAll(".search__items-list");
    if (results.length && searchTabs.length) {
      results[0].classList.add("active");
      searchTabs[0].classList.add("active");
    }
    searchTabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        const typeTarget = tab.dataset.typeTarget;
        searchTabs.forEach((el) => el.classList.remove("active"));
        tab.classList.add("active");
        results.forEach((el) => {
          el.classList.toggle("active", el.dataset.type === typeTarget);
        });
      });
    });
  }

  // Button-with-underline hover helper (guards for missing nodes)
  function initHeaderUnderlineFollower() {
    if (window.screen.width <= 990) return;
    let attachedHeader = false;

    const headerSection = document.querySelector(".shopify-section-header");
    const imageContainerHeader = headerSection?.querySelector(".button--with-underline--container");
    if (!headerSection || !imageContainerHeader) return;

    const followMouseHeader = (event) => {
      imageContainerHeader.style.left = event.pageX + "px";
      const y = event.pageY - window.scrollY - headerSection.offsetHeight + 30;
      imageContainerHeader.style.top = y + "px";
    };

    function showTextHeader() {
      if (!attachedHeader) {
        attachedHeader = true;
        imageContainerHeader.style.display = "block";
        document.addEventListener("pointermove", followMouseHeader);
      }
    }

    function hideTextHeader() {
      if (attachedHeader) {
        attachedHeader = false;
        imageContainerHeader.style.display = "";
        document.removeEventListener("pointermove", followMouseHeader);
      }
    }

    // If you have triggers, bind them here; otherwise, leave helpers available:
    headerSection.addEventListener("mouseenter", showTextHeader);
    headerSection.addEventListener("mouseleave", hideTextHeader);
  }

  /* ---------- bootstrap ---------- */
  ready(() => {
    initHeader();
    bindSearchCloseButton();
    bindPredictiveSearchTabs();
    initHeaderUnderlineFollower();
  });
})();
